import { render, staticRenderFns } from "./MilestoneTemplateNew.vue?vue&type=template&id=dd4f0a08&"
import script from "./MilestoneTemplateNew.vue?vue&type=script&lang=js&"
export * from "./MilestoneTemplateNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports